<template>
  <div class="promote flex flex-y">
    <div class="width-full text-0 relative">
      <img
        class="width-full"
        :src="require('@/assets/images/promote/bg.png') + `?timestamp=${new Date().valueOf()}`"
        alt="邀请车主奖13元现金"
      />
      <button class="absolute text-14 text-white" @click="handleRule">
        活动规则
      </button>
    </div>
    <div class="content text-14 text-white">
      <template v-if="valid === 2">
        <button @click="handleInvite" class="width-full text-0 flex">
          <img
            class="width-full"
            src="@/assets/images/promote/btn.png"
            alt="邀请好友"
          />
        </button>
        <div
          @click="handleQrcode"
          class="flex flex-center margin-top-20 text-0"
        >
          <div class="text-500 text-16" style="color: #ffeae0">面对面邀请</div>
          <img
            style="margin-left: 5px; height: 13px"
            src="@/assets/images/promote/arrow-right-pinklight.png"
            alt=""
          />
        </div>
      </template>
      <template v-else>
        <img
          v-if="valid === 0"
          src="~assets/images/promote/start.png"
          alt=""
          srcset=""
        />
        <img
          v-if="valid === 1"
          src="~assets/images/promote/end.png"
          alt=""
          srcset=""
        />
      </template>
      <div class="bg-red padding-bottom-2">
        <div class="flex padding-lr-16 align-center justify-between">
          <div class="text-17 text-500 text-16">我的奖励</div>
          <div
            v-if="!isMiniprogram"
            @click="goWithdrawal"
            class="bg-reddeep flex flex-center"
          >
            <div>去提现</div>
            <img src="@/assets/images/promote/arrow-right.png" />
          </div>
        </div>
        <div class="flex margin-top-20 padding-bottom-20">
          <div
            v-for="item in bonus"
            :key="item.text"
            class="flex-1 flex flex-y flex-center"
          >
            <div class="margin-bottom-8">
              <span class="text-700">{{ item.num }}</span>
              {{ item.unit }}
            </div>
            <div class="flex flex-center text-12">
              {{ item.text }}
              <img
                v-if="item.img"
                @click="showTips"
                style="width: 11px; margin-left: 2px"
                src="@/assets/images/promote/wenhao@2x.png"
                alt="提示"
              />
            </div>
          </div>
        </div>
        <div v-if="users.length" class="border-top-red">
          <div class="flex justify-between circle"></div>
          <div class="padding-lr-16" style="color: #ffe0d4">
            <div class="margin-top-20" v-for="item in users" :key="item.id">
              <div class="flex align-center">
                <img
                  class="avatar margin-right-8"
                  src="@/assets/images/promote/avatar.png"
                  alt=""
                />
                <div class="flex-1">
                  <div class="text-14">{{ item.inviteeMobile }}</div>
                  <div class="text-11 margin-top-2">{{ item.createTime }}</div>
                </div>
                <div v-if="item.rewardStatus === 0" class="text-12">
                   在路上
                </div>
                <div v-if="item.rewardStatus === 1" class="text-12">
                   已到账
                </div>
              </div>
            </div>
          </div>
          <div @click="handleRecord" class="padding-tb-22 flex flex-center">
            <div style="color: #ffd9cb">查看完整邀请记录</div>
            <img
              class="arrow-right margin-left-4"
              src="@/assets/images/promote/arrow-right-pink.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <wx-mini-app-share :show.sync="showShare"></wx-mini-app-share>
  </div>
</template>

<script>
import {
  getActivityInviteInfo,
  getActivityInfoById
} from '@/api/modules/promote'
import { handleApp, handleInvite } from '@/utils/handle_app'
import validActivity from '@/utils/valid_activity'
import WxMiniAppShare from 'cmp/share'

export default {
  components: {
    WxMiniAppShare
  },
  data () {
    return {
      showShare: false,
      bonus: [
        { num: 0, unit: '元', text: '累计获得' },
        { num: 0, unit: '人', text: '奖励在路上', img: 'wenhao@2x.png' },
        { num: 0, unit: '人', text: '成功邀请' }
      ],
      users: [],
      showAll: false,
      pageParams: {
        current: 1,
        size: 3,
        activityId: 212570000009
      },
      isMiniprogram: window.__wxjs_environment === 'miniprogram',
      valid: 2
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const { pageParams } = this

      getActivityInviteInfo(pageParams).then((data) => {
        this.bonus[0].num = data.sumBonus || 0
        this.bonus[1].num = data.partBountyCount
        this.bonus[2].num = data.allBountyCount

        const { records } = data.pageList

        this.users = records
      })

      getActivityInfoById(pageParams.activityId).then((res) => {
        const valid = validActivity(res.activityStartTime, res.activityEndTime)
        this.valid = valid
      })
    },

    goWithdrawal () {
      handleApp('withdrawal')
    },

    showTips () {
      this.$dialog
        .alert({
          message: '邀请关系绑定成功，TA规定时间内完成首单，您可得奖励',
          theme: 'round-button',
          closeOnClickOverlay: true,
          confirmButtonText: '知道了'
        })
        .then(() => {
          // on close
        })
    },
    toggleAll () {
      this.showAll = !this.showAll
    },
    handleRule () {
      this.$router.push('/agreement/detail/21165000000003')
    },
    handleInvite () {
      handleInvite('driver', () => {
        this.showShare = true
      })
    },
    handleQrcode () {
      this.$router.push('/promote/driver/qrcode')
    },
    handleRecord () {
      this.$router.push('/promote/driver/record')
    }
  }
}
</script>

<style lang="scss" scoped>
.promote {
  min-height: 100vh;
  background-color: #ff5c1a;

  button {
    padding: 0px;
    margin: 0px;
    outline: none;
    border: none;
    text-align: center;
    background-color: transparent;
  }

  .text-0 {
    font-size: 0px;
  }

  .text-500 {
    font-weight: 500;
  }

  .text-17 {
    font-size: 17px;
  }

  .text-11 {
    font-size: 11px;
    color: #ffaa93;
  }

  .text-700 {
    font-weight: 700;
    font-size: 25px;
    font-family: DIN Alternate, DIN Alternate-Bold;
  }

  img + button.absolute {
    width: 85px;
    height: 30px;
    right: 0px;
    top: 8.395%;
    color: #ffe0d4;
    background-color: rgba(255, 255, 255, 0.22);
    border-radius: 15px 0px 0px 15px;
  }

  .content {
    padding: 10px 16px 40px;

    .bg-red {
      padding-top: 21px;
      margin-top: 21px;
      border-radius: 10px;
      background-color: #ff410e;
    }

    .bg-reddeep {
      width: 87px;
      height: 30px;
      border-radius: 15px;
      background-color: #ea3200;

      img {
        width: 6px;
        height: auto;
        margin-left: 5px;
      }
    }

    .circle {
      margin: -6px;

      &::before,
      &::after {
        content: "";
        width: 12px;
        height: 12px;
        display: block;
        border-radius: 50%;
        background-color: #ff5c1a;
      }
    }
  }

  .border-top-red {
    border-top: 1px solid #d22c00;

    .avatar {
      width: 35px;
      height: 35px;
      border-radius: 50%;
    }

    .arrow-right {
      width: 6px;
      height: 10px;
    }
  }
}
</style>
